//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  layout: 'auth',
  middleware: 'guest',
  auth: false,
  data: () => ({
    formData: {},
    needsTwoFactor: false,
    loading: false,
  }),
  methods: {
    async login() {
      try {
        this.loading = true;
        await this.$auth.loginWith('apollo', {data: this.formData});
        const options = {
          email: this.formData.email,
        };
        this.$gtm.push({event: 'authenticate', ...options});
        await this.$router.push(this.$route.query.redirect || this.localeRoute({name: 'index'}));
      } catch (err) {
        if (err.graphQLErrors?.find(error => error.extensions.category === '2fa') && !this.formData.two_factor_code) {
          this.needsTwoFactor = true;
        } else if (err.graphQLErrors?.find(error => error.extensions.category === '2fa')) {
          this.$toast.error('Incorrecte tweestapsauthenticatiecode opgegeven.');
        } else if (err.graphQLErrors?.find(error => error.extensions.category === 'validation')) {
          this.$toast.error('Fout bij het inloggen, controleer uw e-mailadres en wachtwoord.');
        } else {
          console.error(err);

          this.$toast.error(err.graphQLErrors?.[0]?.message || 'Er is iets fout gegaan.');
        }

        this.loading = false;
      }
    },
  },
};
